import { render, staticRenderFns } from "./BasuView.vue?vue&type=template&id=74c33bd0&"
import script from "./BasuView.vue?vue&type=script&lang=js&"
export * from "./BasuView.vue?vue&type=script&lang=js&"
import style0 from "./BasuView.vue?vue&type=style&index=0&id=74c33bd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports